// import React, { useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import { Carousel, Image } from 'react-bootstrap'
// import { useDispatch, useSelector } from 'react-redux'
// import Loader from './Loader'
// import Message from './Message'
// import { listTopProducts } from '../actions/productActions'

// const ProductCarousel = () => {
//   const dispatch = useDispatch()

//   const productTopRated = useSelector((state) => state.productTopRated)
//   const { loading, error, products } = productTopRated

//   useEffect(() => {
//     dispatch(listTopProducts())
//   }, [dispatch])

//   return loading ? (
//     <Loader />
//   ) : error ? (
//     <Message variant='danger'>{error}</Message>
//   ) : (
//     <Carousel pause='hover' className='bg-primary'>
//       {products.map((product) => (
//         <Carousel.Item key={product._id}>
//           <Link to={`/product/${product._id}`}>
//             <Image src={product.image} alt={product.name} fluid />
//             <Carousel.Caption className='carousel-caption'>
//               <h2>
//                 {product.name} (${product.price})
//               </h2>
//             </Carousel.Caption>
//           </Link>
//         </Carousel.Item>
//       ))}
//     </Carousel>
//   )
// }

// export default ProductCarousel


import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Carousel, Image } from 'react-bootstrap';
import { normalizeImageUrl } from '../utils/urlSanitizer';
import { useDispatch, useSelector } from 'react-redux';
import Loader from './Loader';
import Message from './Message';
import { listTopProducts } from '../slices/productSlice'; // ✅ use the slice action

const ProductCarousel = () => {
  const dispatch = useDispatch();

  // ✅ use new slice structure
  const { loadingTop, errorTop, topProducts = [] } = useSelector((state) => state.productList);

  useEffect(() => {
    dispatch(listTopProducts());
  }, [dispatch]);

  if (!loadingTop && !errorTop && (!Array.isArray(topProducts) || topProducts.length === 0)) {
    return null;
  }

  return loadingTop ? (
    <Loader />
  ) : errorTop ? (
    <Message variant='danger'>{errorTop}</Message>
  ) : (
      <Carousel pause='hover' className='bg-primary'>
        {(topProducts || []).map((product) => {
          const name = product?.name || '';
          const truncatedTitle = name.length > 44 ? name.slice(0, 44) + '...' : name;
          return (
            <Carousel.Item key={product._id}>
              <Link to={`/product/${product._id}`}>
                <Image src={normalizeImageUrl(product.image)} alt={product.name} fluid />
                <Carousel.Caption className='carousel-caption'>
                  <h2 title={name}>
                    {truncatedTitle} (${product.price})
                  </h2>
                </Carousel.Caption>
              </Link>
            </Carousel.Item>
          );
        })}
      </Carousel>
  );
};

export default ProductCarousel;


// import React, { useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { Carousel, Image } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import Loader from './Loader';
// import Message from './Message';
// import { listTopProducts } from '../slices/productSlice';

// const ProductCarousel = () => {
//   const dispatch = useDispatch();

//   const { loading, error, topProducts = [] } = useSelector((state) => state.product);

//   useEffect(() => {
//     dispatch(listTopProducts());
//   }, [dispatch]);

//   // Helper: hard truncate to 44 chars and append ellipsis
//   const truncate44 = (str = '') => (str.length > 44 ? `${str.slice(0, 44)}...` : str);

//   // Small, reusable style to guarantee one-line ellipsis and centering
//   const oneLineEllipsis = {
//     whiteSpace: 'nowrap',
//     overflow: 'hidden',
//     textOverflow: 'ellipsis',
//   };

//   return loading ? (
//     <Loader />
//   ) : error ? (
//     <Message variant="danger">{error}</Message>
//   ) : (
//     <Carousel pause="hover" className="bg-primary">
//       {topProducts.map((product) => (
//         <Carousel.Item key={product._id} className="text-center">
//           <Link to={`/product/${product._id}`} className="text-decoration-none text-reset">
//             {/* Title (single line, above image) */}
//             <h2
//               className="m-0 py-2 text-center"
//               style={oneLineEllipsis}
//               title={product.name}
//             >
//               {truncate44(product.name)}
//             </h2>

//             {/* Image */}
//             <Image src={product.image} alt={product.name} fluid />

//             {/* Price (below image) */}
//             <div className="py-2">
//               <strong>${product.price}</strong>
//             </div>
//           </Link>
//         </Carousel.Item>
//       ))}
//     </Carousel>
//   );
// };

// export default ProductCarousel;

